<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">EDIT BANK DETAILS</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-select
              v-model="bank_type_1"
              dense
              outlined
              label="(Primary) Bank Type"
              :items="['EASTWEST','BDO NETWORK','OTHERS']"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_1"
              dense
              label="(Primary) Account Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_no_1"
              dense
              label="(Primary) Account Number"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2 mt-9">
          <v-flex xs12 md12>
            <v-select
              v-model="bank_type_2"
              dense
              outlined
              label="(Secondary) Bank Type"
              :items="['EASTWEST','BDO NETWORK','OTHERS']"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_2"
              dense
              label="(Secondary) Account Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_no_2"
              dense
              label="(Secondary) Account Number"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2 mt-9">
          <v-flex xs12 md12>
            <v-select
              v-model="bank_type_3"
              dense
              outlined
              label="(Optional) Bank Type"
              :items="['EASTWEST','BDO NETWORK','OTHERS']"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_3"
              dense
              label="(Optional) Account Name"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="bank_account_no_3"
              dense
              label="(Optional) Account Number"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{alert_message}}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

  import {mdiAlertOutline} from "@mdi/js";
  import {mapActions, mapGetters} from "vuex";

  const initialState = () => {
    return {
      saving_request: false,
      alert: false,
      alert_message: '',

      bank_type_1: '',
      bank_account_1: '',
      bank_account_no_1: '',
      bank_type_2: '',
      bank_account_2: '',
      bank_account_no_2: '',
      bank_type_3: '',
      bank_account_3: '',
      bank_account_no_3: '',
    }
  }
  export default {
    props: {
      member_information: Object,
    },
    setup() {
      return {
        icons: {
          mdiAlertOutline,
        },
      }
    },
    data() {
      return initialState();
    },
    mounted() {
      this.bank_type_1 = this.member_information.bank_type_1
      this.bank_account_1 = this.member_information.bank_account_1
      this.bank_account_no_1 = this.member_information.bank_account_no_1
      this.bank_type_2 = this.member_information.bank_type_2
      this.bank_account_2 = this.member_information.bank_account_2
      this.bank_account_no_2 = this.member_information.bank_account_no_2
      this.bank_type_3 = this.member_information.bank_type_3
      this.bank_account_3 = this.member_information.bank_account_3
      this.bank_account_no_3 = this.member_information.bank_account_no_3
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('authentication', ['employee_id']),
    },
    methods: {

      ...mapActions('employee', ['change_bank_details']),
      done_request() {
        this.saving_request = true
        this.alert = false
        if (this.$refs.form.validate()) {
          const data = new FormData()
          data.append('id', this.member_information.id);
          data.append('bank_type_1', this.bank_type_1);
          data.append('bank_account_1', this.bank_account_1);
          data.append('bank_account_no_1', this.bank_account_no_1);
          data.append('bank_type_2', this.bank_type_2);
          data.append('bank_account_2', this.bank_account_2);
          data.append('bank_account_no_2', this.bank_account_no_2);
          data.append('bank_type_3', this.bank_type_3);
          data.append('bank_account_3', this.bank_account_3);
          data.append('bank_account_no_3', this.bank_account_no_3);
          this.change_bank_details(data)
            .then(response => {
              this.$emit('response', response)
              this.saving_request = false
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_request = false
        }
      },
    }
  }
</script>
